function sendRegistration({ state, output, services }) {
  let currentPage = state.get('client.currentPage')
  let current = state.get(`client.registrating.current.${currentPage}`)
  let fields = Object.keys(current).map(key => {
    return {
      key,
      value: current[key].value,
      viesValidation: current[key].viesValidation || false,
      validateAgainst: current[key].validateAgainst || null
    }
  })

  services.Http
    .post('/api/validation', { fields, name: currentPage })
    .then(output.success)
    .catch(output.error)
}

sendRegistration.async = true
export default sendRegistration



// WEBPACK FOOTER //
// ./src/modules/login/actions/sendRegistration.js